<template>
  <div>
    <div id="maintitle">
      <h2>
        <img
          :src="
            require(`@assets/images/pc/original/agent-selection/secret/as_mv_side.jpg`)
          "
          alt="無料転職サポート！m3.com提携転職支援会社３社の求人をまとめて比較。あなたにピッタリな求人が見つかる！"
        />
      </h2>
      <div class="agentselection_form-area">
        <div class="agentselection_form-step01" id="new_agent_selection_wish">
          <div class="agentselection_form-step01_images">
            <img
              :src="
                require(`@assets/images/pc/original/agent-selection/secret/as_mv_top.png`)
              "
              alt="無料転職サポート！m3.com提携転職支援会社３社の求人をまとめて比較。あなたにピッタリな求人が見つかる！"
            />
          </div>
          <div class="agentselection_form-inner">
            <table>
              <tbody>
                <tr>
                  <th>
                    <img
                      :src="
                        require(`@assets/images/pc/original/agent-selection/secret/as_img01.png`)
                      "
                      alt="（1）ご希望エリア"
                      width="136"
                      height="26"
                    />
                  </th>
                  <td colspan="3">
                    <div>
                      <prefecture-id-form />
                      <address-form />
                    </div>
                    <p>&nbsp;</p>
                    <br />
                  </td>
                </tr>
                <tr>
                  <th>
                    <img
                      :src="
                        require(`@assets/images/pc/original/agent-selection/secret/as_img02.png`)
                      "
                      alt="（2）ご希望業種"
                      width="136"
                      height="26"
                    />
                  </th>
                  <td>
                    <position-type-form />
                  </td>
                  <th>
                    <img
                      :src="
                        require(`@assets/images/pc/original/agent-selection/secret/as_img03.png`)
                      "
                      alt="（3）雇用形態"
                      width="152"
                      height="26"
                    />
                  </th>
                  <td>
                    <employment-type-form />
                  </td>
                </tr>
              </tbody>
            </table>
            <agent-selection-auction-ids-form />
          </div>
          <div class="text-center newaslp_bt newaslp_bt_btn">
            <conversion-button
              @click="handleConversionButtonClicked"
              display-appealing-text
              activated-disabled
            />
          </div>
        </div>
      </div>
    </div>
    <!--希望にピッタリの求人-->
    <div class="newaslp-font">
      <h3 class="newaslp">
        あなたの<span>希望にピッタリの求人</span>を支援会社からご紹介いたします。
      </h3>
      <img
        :src="
          require(`@assets/images/pc/original/agent-selection/secret/as_img04.png`)
        "
        alt="あなたの希望にピッタリの職場見つけられていますか?"
        width="820"
        height="304"
        class="img-cc"
      />
      <div class="newaslp-conbox clearfix">
        <div class="newaslp-con">
          <div class="as-contit">自分で探すより簡単</div>
          <div class="as-conny">
            検索不要！希望を伝えてあとは「待つだけ」でokです。
          </div>
        </div>
        <div class="newaslp-con">
          <div class="as-contit">非公開求人もご紹介</div>
          <div class="as-conny">
            新着求人や、応募殺到するため公開できない求人などサイト上で公開されない求人までご紹介
          </div>
        </div>
        <div class="newaslp-con">
          <div class="as-contit">条件交渉もおまかせ</div>
          <div class="as-conny">
            勤務条件の交渉など転職のプロがサポートします。
          </div>
        </div>
      </div>
      <div class="text-center newaslp_bt02 newaslp_bt_btn">
        <conversion-button @click="handleConversionButtonClicked" />
      </div>
    </div>
    <!--/希望にピッタリの求人-->
    <!--求人紹介までの流れ-->
    <div class="newaslp-font">
      <h3 class="newaslp"><span>求人紹介</span>までの流れ</h3>
      <div class="m3p_mt20" style="font-size: 14px;">
        ご登録後、コンサルタントから詳しいご希望をうかがうためご連絡いたします。
      </div>
      <img
        :src="
          require(`@assets/images/pc/original/agent-selection/secret/as_img05.png`)
        "
        alt="求人ご紹介までの流れ　ご登録後、コンサルタントから詳しいご希望をうかがうためご連絡いたします"
        width="920"
        height="104"
        class="img-cc"
      />
      <div class="newaslp-conbox02 clearfix">
        <div class="newaslp-con02">
          <div class="as-conny-a">
            ご希望エリア・条件を入力して相談依頼をスタート！最短即日3日以内に各社からメール・電話での連絡がありますので、より具体的な内容をご相談下さい。
          </div>
        </div>
        <div class="newaslp-con02">
          <div class="as-conny-b">
            各社からご希望に沿った求人のご紹介がありますので、より具体的に知りたい求人や面談へ進めたいものがあれば担当スタッフへご連絡下さい。
          </div>
        </div>
        <div class="newaslp-con02">
          <div class="as-conny-c">
            面談日程の調整やアドバイスは各社の専任スタッフにお任せ下さい。<br />面談した中で、最も良いと感じた職場へご入職ください。
          </div>
        </div>
      </div>
      <div class="text-center newaslp_bt02 newaslp_bt_btn">
        <conversion-button @click="handleConversionButtonClicked" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useForm } from "vee-validate";
import ConversionButton from "@component_path/pages/pc/agent_selection/secret/components/ConversionButton";
import PrefectureIdForm from "@component_path/pages/pc/agent_selection/secret/components/form_item_template/PrefectureId";
import AddressForm from "@component_path/pages/pc/agent_selection/secret/components/form_item_template/Address";
import PositionTypeForm from "@component_path/pages/pc/agent_selection/secret/components/form_item_template/PositionType";
import EmploymentTypeForm from "@component_path/pages/pc/agent_selection/secret/components/form_item_template/EmploymentType";
import AgentSelectionAuctionIdsForm from "@component_path/pages/pc/agent_selection/secret/components/form_item_template/AgentSelectionAuctionIds";

const props = defineProps({
  master_data: {
    type: Object,
    required: true
  },
  form_options: {
    type: Object,
    required: true
  },
  preferred_prefecture: {
    type: String,
    required: false
  },
  inquiry_form_path: {
    type: String,
    required: true
  }
});

const store = useStore();
const { validate } = useForm();

const handleConversionButtonClicked = async () => {
  const { valid } = await validate();
  if (valid) {
    location.href = store.getters["inquiryFormPath"]("secret");
  } else {
    const targetAnchor = document.getElementById("maintitle");
    window.scroll({
      top: targetAnchor.offsetTop,
      behavior: "smooth"
    });
  }
};
store.dispatch("formData/initFormOptions", props.form_options);
store.dispatch("masterData/initMasterData", props.master_data);
store.dispatch("setInquiryFormPath", props.inquiry_form_path);
store.dispatch("setMaxSelectCount", 3);
</script>
